import { forms, skins } from 'src/vuex/getters'
import { setFormData,
         removeFormField } from 'src/vuex/actions'
import _ from 'lodash'

export default {
  vuex: {
    getters: {
      skins,
      forms
    },
    actions: {
      setFormData,
      removeFormField
    }
  },

  props: ['uid', 'rendered'],

  events: {
    'fdata::group' (input) {
      _.forOwn(input, (val, key) => {
        this.setFormData({ [key]: val }, this.index)
      })
    },
    // collect data from form fields
    'fdata::input' (input) {
      this.setFormData(input, this.index)
    },
    'fdata::remove' (keys) {
      this.removeFormField(keys, this.index)
    },
    'fdata::validate' () {
      this.$broadcast('force::validate')
    },
    'fdata::submit' () {
      this.$broadcast('force::submit')
    }
  },

  computed: {
    form () {
      return _.find(this.forms, ['uid', this.uid])
    },

    index () {
      return _.findIndex(this.forms, ['uid', this.uid])
    },

    id () {
      return this.uid.toLowerCase()
                     .replace(/\./g, '-')
                     .split('_')[0]
    },
    /**
    * The class of the form
    */
    formClass () {
      return this.form.class
    },

    isCollapsed () {
      return this.form.class === 'accountSelect01' ? false : this.collapsed
    },
    /**
     * Check if we are dealing with a form with a simple type check
     */
    isForm () {
      if (typeof this.form !== 'undefined') {
        return this.form.fields.length > 0
      }
      return false
    },
    /**
     * Retrieve any form tooltips
     */
    tip () {
      if (typeof this.form !== 'undefined') {
        return this.form.tip
      }
    },
    /**
     * Retrieve the form title
     */
    title () {
      if (typeof this.form !== 'undefined') {
        return this.forms.title
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/_shared/traits.js